function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import Loader from '../apricot/Loader';
import Error from '../apricot/Error';
import Breakpoint from '../breakpoint';
import SchoolBand from './SchoolBand';
import Mobile from './Mobile';
import Panels from './Panels';
import styles from '../../../sass/status.module.scss';

// configurable properities
// loading (optional, shows spinner)
// error (optional, shows error component)
// data (required to show panel)
// showSchoolBand (optional, shows band with coordinator, principal and access codes)
// hideOrderPanel (optional, defaults to false)
// hideStudentRegistrations (optional, defaults to false)
// history (optional, create links using react router vs regular hyperlinks vs no links (value will be false))
export default Breakpoint(function (_ref) {
  var _ref$hideOrderPanel = _ref.hideOrderPanel,
    hideOrderPanel = _ref$hideOrderPanel === void 0 ? false : _ref$hideOrderPanel,
    _ref$showSchoolBand = _ref.showSchoolBand,
    showSchoolBand = _ref$showSchoolBand === void 0 ? true : _ref$showSchoolBand,
    _ref$hideStudentRegis = _ref.hideStudentRegistrations,
    hideStudentRegistrations = _ref$hideStudentRegis === void 0 ? false : _ref$hideStudentRegis,
    history = _ref.history,
    loading = _ref.loading,
    error = _ref.error,
    data = _ref.data,
    _ref$breakpoint = _ref.breakpoint,
    mobile = _ref$breakpoint.mobile,
    tablet = _ref$breakpoint.tablet;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var props = _objectSpread(_objectSpread({}, data), {}, {
    hideOrderPanel: hideOrderPanel,
    hideStudentRegistrations: hideStudentRegistrations,
    history: history
  });
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  if (error) return /*#__PURE__*/React.createElement(Error, {
    message: error,
    title: "Error retrieving status information"
  });
  if (data) return /*#__PURE__*/React.createElement("div", {
    "aria-label": "Status Panel",
    role: "region",
    className: styles['status-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, showSchoolBand && !mobile && !tablet ? /*#__PURE__*/React.createElement(SchoolBand, data.school) : null, mobile ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-expanded": open,
    className: styles['status-button'],
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, open ? 'Collapse' : 'Expand', " Status", ' ', /*#__PURE__*/React.createElement("i", {
    className: "cb-glyph ".concat(open ? 'cb-minus' : 'cb-plus'),
    "aria-hidden": true
  })) : null, mobile && !open ? /*#__PURE__*/React.createElement(Mobile, props) : /*#__PURE__*/React.createElement(Panels, props)));
  return null;
});